import { useEffect } from 'react';
import { useCarriers } from './useCarriers';
import { useCartStore, updateGlobalCarriers } from '../store/useCartStore';

/**
 * Hook que sincroniza los carriers con el store del carrito
 * Este hook debe ser usado en el componente principal de la aplicación
 * para asegurar que los carriers estén disponibles para el cálculo del carrito
 */
export const useCartWithCarriers = () => {
  const { data: carriers, isLoading, error } = useCarriers();
  const updateCarriers = useCartStore((state) => state.updateCarriers);

  useEffect(() => {
    if (carriers && !isLoading && !error) {
      // Actualizar los carriers globales
      updateGlobalCarriers(carriers);
      // Actualizar el store con los nuevos carriers
      updateCarriers(carriers);
    }
  }, [carriers, isLoading, error, updateCarriers]);

  return {
    carriers,
    isLoading,
    error,
  };
};
